import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import Label from "../../ui/Label/Label";
import Textarea from "../../ui/Textarea/Textarea";
import Badge from "../../ui/Badge/Badge";
import Button from "../../ui/Button/Button";
import styles from "./DetailsForm.module.scss";

function DetailsForm({
  label,
  onSubmit,
  onBack,
  value,
  isFinalStep,
  disabled,
}: {
  label: string;
  onSubmit: (data: { value: string }) => Promise<void>;
  onBack: () => void;
  value?: string | null;
  isFinalStep?: boolean;
  disabled?: boolean;
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting },
  } = useForm({
    defaultValues: { value: value ?? "" },
  });

  useEffect(() => {
    if (!isDirty) {
      reset({ value: value ?? "" });
    }
  }, [value, isDirty, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <Label label={label} className={styles.label} size="large">
        {value ? (
          <Controller
            control={control}
            name="value"
            render={({ field }) => (
              <Textarea
                {...field}
                className={styles.input}
                autosize
                autofocus
              />
            )}
          />
        ) : (
          <div className={styles.input}>
            <Badge loading color="purple" showDot={false}>
              Learning
            </Badge>
          </div>
        )}
      </Label>
      <div className={styles.footer}>
        <Button
          variant="outline"
          size="small"
          onClick={onBack}
          disabled={isSubmitting || disabled}
        >
          Back
        </Button>
        <Button
          variant="primary"
          size="small"
          type="submit"
          loading={isSubmitting}
          disabled={!value || isSubmitting || disabled}
        >
          {isFinalStep ? "Done" : "Next"}
        </Button>
      </div>
    </form>
  );
}

export default DetailsForm;
